const Area = ({ area }: { area: string }) => (
  <div className="summary-item-box">
    <div className="row">
      <div className="summary-txt-box type-2">지역 {area}</div>
    </div>
  </div>
);
export default Area;
